import React, { useState, useEffect, useMemo, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '../../Auth/AuthContext';
import { useTheme } from '@mui/material/styles';
import { Typography, Paper, Box, TableRow, TableCell, TableBody, TextField, TableContainer, Table, Pagination, TableHead, Button } from '@mui/material';

import { green, blue, grey } from '@mui/material/colors';

import VistaTurno from '../SubComponents/Caja/VistaTurno';
import RowTableCaja from '../SubComponents/Caja/RowTableCaja';

const API_URL = process.env.REACT_APP_API_URL;

export async function fetchCashboxById(apiUrl, cashboxId, httpClient = axios) {
  const response = await httpClient.get(`${apiUrl}/cajas/${cashboxId}/`);
  if (String(response.data?.id) !== String(cashboxId)) {
    throw new Error('La caja refrescada no coincide con la caja seleccionada.');
  }
  return response.data;
}

async function actualizarReporteDiario(caja) { 
  try { 
    const response = await axios.get(`${API_URL}/reporte_diario_cajas/`); 
    const reportes = response.data; 
    const fecha = caja.fecha_hora_inicio.split(' ')[0];
    
    const tipos = ['ingreso', 'egreso', 'dinero_base'];

    console.log(reportes)

    for (let tipo of tipos) {
      const reporte = reportes.find(
        r => r.fecha === fecha && r.tipo === tipo
      );

      if (!reporte) continue;

      let valorARestar = 0;
      if (tipo === 'ingreso') valorARestar = parseFloat(caja.total_ingresos || 0);
      else if (tipo === 'egreso') valorARestar = parseFloat(caja.total_egresos || 0);
      else if (tipo === 'dinero_base') valorARestar = parseFloat(caja.dinero_base || 0);

      const nuevoValor = parseFloat(reporte.valor) - valorARestar;

      await axios.put(`${API_URL}/reporte_diario_cajas/${reporte.id}/`, {
        valor: nuevoValor,
        tipo,
      });
    }
  } 
  catch (error) { console.error("Error actualizando Reporte Diario:", error); } 
}


function bubbleSort(arr) {
  let n = arr.length;
  for (let i = 0; i < n - 1; i++) {
    for (let j = 0; j < n - i - 1; j++) {
      if (arr[j].id < arr[j + 1].id) {
        [arr[j], arr[j + 1]] = [arr[j + 1], arr[j]]; // Ordenar por ID de forma descendente
      }
    }
  }
  return arr;
}

const formatNumber = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

function Caja() {
  const { user } = useAuth();
  const areUserAdmin = user.rol === 'Administrador';

  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  const [cajas, setCajas] = useState([]);
  const [currentCaja, setCurrentCaja] = useState(null);

  const [refresh, setRefresh] = useState(false);

  const [searchInput, setSearchInput] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [count, setCount] = useState(0);

  const [seeAdminCaja, setseeAdminCaja] = useState(false);
  const [seeCaja, setseeCaja] = useState(false);

  const [resumenFinanciero, setResumenFinanciero] = useState({
    total_ingresos: 0,
    total_egresos: 0,
    total_sin_devengar: 0,
    total_devengado: 0,
  });

  const [currentSeeCaja, setCurrentSeeCaja] = useState(null)
  const rowsPerPage = 8;

  const handleRefresh = useCallback(async () => {
    const selectedCashboxId = currentCaja?.id;
    setRefresh(prev => !prev);
    if (!selectedCashboxId) return;

    const refreshedCashbox = await fetchCashboxById(API_URL, selectedCashboxId);
    setCurrentCaja(refreshedCashbox);
    if (seeCaja) {
      setCurrentSeeCaja(refreshedCashbox);
    }
  }, [currentCaja?.id, seeCaja]);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${API_URL}/cajas/`, {
          params: {
            page: currentPage,
            search: searchTerm,
          },
        });
        const resumenFinancieroRes = await axios.get(`${API_URL}/resumen-financiero-cajas/`);

        setResumenFinanciero(resumenFinancieroRes.data);

        const results = res.data.results || res.data;
        setCajas(results);
        setCount(res.data.count || results.length);
        setTotalPages(Math.ceil((res.data.count || results.length) / rowsPerPage));
      } catch (error) {
        console.error('Error al cargar los datos:', error);
      }
    };
    fetchData();
  }, [refresh, currentPage, searchTerm]);

  const handleDeleteCaja = async (caja) => {
    await actualizarReporteDiario(caja);

    try {
      await axios.delete(`${API_URL}/cajas/${caja.id}/`);
      setCajas(prevCajas => prevCajas.filter((item) => item.id !== caja.id));
      setCount((prev) => Math.max(0, prev - 1));
    } catch (error) {
      console.error('Error deleting caja:', error);
    }
  };

  useEffect(() => {
    const fetchCurrentCaja = async () => {
      // Traemos la caja activa del usuario (si existe)
      try {
        const userRes = await axios.get(`${API_URL}/usuarios/`); // pone params
        console.log(userRes.data)
        const userId = userRes.data.filter(u => u.nombre === user.nombre)[0].id;
        console.log(userRes.data.filter(u => u.nombre === user.nombre)[0])
        const res = await axios.get(`${API_URL}/cajas/`, {
          params: {
            empleado_id: userId,
            estado: true,
          },
        });

        const results = res.data.results || res.data;
        setCurrentCaja(results[0] || null);
      } catch (error) {
        console.error('Error al obtener la caja del usuario:', error);
      }
    };
    if (seeAdminCaja) {
      fetchCurrentCaja();
      return;
    }
    if (!areUserAdmin) {
      fetchCurrentCaja();
    } else if (seeCaja && currentSeeCaja) {
      // Cuando el admin selecciona una caja para ver
      setCurrentCaja(currentSeeCaja);
    }
  }, [user.id, areUserAdmin, seeCaja, currentSeeCaja, refresh, seeAdminCaja]);

  const handlePageChange = useCallback((event, value) => {
    setCurrentPage(value);
  }, []);

  const handleSearchChange = useCallback((event) => {
    setSearchInput(event.target.value);
  }, []);

  const handleSearchKeyDown = useCallback((event) => {
    if (event.key === 'Enter') {
      setSearchTerm(searchInput);
      setCurrentPage(1);
    }
  }, [searchInput]);

  const currentcajas = useMemo(() => {
    return cajas;
  }, [cajas]);

  const handleEditCaja = (caja) => {setCurrentCaja(caja); setCurrentSeeCaja(caja); setseeCaja(true);};

  return (
    <>
      {(!areUserAdmin || seeAdminCaja || seeCaja) ? (
        <VistaTurno goBackWithAdmin={() => {setseeAdminCaja(false); setseeCaja(false);}} currentCaja={currentCaja} handleRefresh={handleRefresh}/>
      ) : (
        <Box sx={{ paddingTop: 1, position: 'relative', height: '100%' }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ paddingTop: '20px' }}>
            <Typography variant='h5' color='grey'>TOTAL DE CAJAS: {count} - INCLUYE TU CAJA</Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
              <Button variant={theme.palette.mode === 'dark' ? "outlined" : "contained"} color="primary" onClick={() => {setseeAdminCaja(true)}} sx={{minWidth: 100,whiteSpace: 'normal',wordBreak: 'break-word',padding: '8px 16px'}}>
                Tu Caja
              </Button>
            </Box>
          </Box>

          <Typography variant="h6" sx={{ paddingBottom: 0 }} gutterBottom color='grey'>
            TOTAL DE INGRESOS: {formatNumber(resumenFinanciero.total_ingresos)} - INCLUYE TU CAJA
          </Typography>
          <Typography variant="h6" sx={{ paddingTop: 0 }} gutterBottom color='grey'>
            TOTAL DE EGRESOS: {formatNumber(resumenFinanciero.total_egresos)} - INCLUYE TU CAJA
          </Typography>
          <Typography variant="h6" sx={{ paddingBottom: 0 }} gutterBottom color='grey'>
            TOTAL SIN DEVENGAR: {formatNumber(resumenFinanciero.total_sin_devengar)} - NO INCLUYE TU CAJA
          </Typography>
          <Typography variant="h6" sx={{ paddingBottom: 0 }} gutterBottom color='grey'>
            TOTAL DEVENGADO: {formatNumber(resumenFinanciero.total_devengado)} - INCLUYE TU CAJA
          </Typography>

          <TextField 
            label="Buscar Caja Por Cualquier Dato (Enter para buscar)"
            variant="outlined"
            sx={{ paddingBottom: 2, paddingTop: 0 }}
            fullWidth
            margin="normal"
            value={searchInput}
            onChange={handleSearchChange}
            onKeyDown={handleSearchKeyDown}
          />
  
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{
              backgroundColor: isDarkMode ? grey[800] : blue[700],
              color: isDarkMode ? 'black' : 'white',
            }}>
              <TableRow>
                <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', fontWeight: 'bold', color: 'white' }}>ID</TableCell>
                <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', fontWeight: 'bold', color: 'white' }}>NOMBRE</TableCell>
                <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', fontWeight: 'bold', color: 'white' }}>MONTO BASE</TableCell>
                <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', fontWeight: 'bold', color: 'white' }}>INGRESOS</TableCell>
                <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', fontWeight: 'bold', color: 'white' }}>EGRESOS</TableCell>
                <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', fontWeight: 'bold', color: 'white' }}>SALDO FINAL</TableCell>
                <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', fontWeight: 'bold', color: 'white' }}>FECHA DE INICIO</TableCell>
                <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', fontWeight: 'bold', color: 'white' }}>FECHA DE SALIDA</TableCell>
                <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', borderRight: areUserAdmin ? null : '2px solid #ddd', fontWeight: 'bold', color: 'white' }}>ESTADO</TableCell>
                { areUserAdmin && <TableCell align="center"sx={{borderLeft: '2px solid #ddd',borderBottom: '2px solid #ddd',borderRight: '2px solid #ddd',fontWeight: 'bold',color: 'white',verticalAlign: 'middle'}}>ACCIONES</TableCell> }
              </TableRow>
            </TableHead>
            <TableBody>
                {currentcajas.map((item) => (
                  <RowTableCaja key={item.id} data={item} handleDelete={handleDeleteCaja} handleEditCaja={handleEditCaja} areUserAdmin={areUserAdmin}/>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
  
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
          <Pagination 
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
      </Box>
      )}
    </>
  );
}

export default Caja;
